// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"D_TheComp__8VTrs"};